export const AddinsData={
    "ListAllPublisher": {
        "RoboDK Inc.": 57,
        "RPR Automation GmbH": 1
    },
    "ListAllCategories": {
        "App": 39,
        "Plug-in": 19
    },
    "DATA_ALL": {
        "com.robodk.app.apptemplate": {
            "N": "App Template",
            "F": "com_robodk_app_apptemplate.rdkp",
            "MD": "com_robodk_app_apptemplate.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The App Template for RoboDK provides the necessary examples to build a RoboDK App.",
            "V": "1.0.0",
            "DC": "2023-01-16T21:00:39.819148Z",
            "DM": "2023-11-03T19:56:42.820144Z",
            "ID": "com.robodk.app.apptemplate",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/AppTemplate",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/AppTemplate"
            },
            "BN": "com_robodk_app_apptemplate"
        },
        "com.robodk.app.blender": {
            "N": "Blender",
            "F": "com_robodk_app_blender.rdkp",
            "I": "com_robodk_app_blender.svg",
            "MD": "com_robodk_app_blender.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Blender App allows you to export RoboDK simulations to Blender for realistic rendering of videos and images.",
            "V": "1.0.0",
            "DC": "2023-07-26T19:17:18.899556Z",
            "DM": "2023-11-03T19:56:52.875293Z",
            "ID": "com.robodk.app.blender",
            "E": "info@robodk.com",
            "CF": 1,
            "PX": {
                "eur": 4000,
                "usd": 4500,
                "cad": 6000
            },
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Blender.html"
            },
            "BN": "com_robodk_app_blender"
        },
        "com.robodk.app.boxspawner": {
            "N": "Box Spawner",
            "F": "com_robodk_app_boxspawner.rdkp",
            "I": "com_robodk_app_boxspawner.svg",
            "MD": "com_robodk_app_boxspawner.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Box Spawner App for RoboDK lets you programmatically add box objects in your RoboDK Station.",
            "V": "1.0.0",
            "DC": "2023-01-16T21:00:39.945263Z",
            "DM": "2023-11-03T19:56:42.865876Z",
            "ID": "com.robodk.app.boxspawner",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/BoxSpawner",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/BoxSpawner"
            },
            "BN": "com_robodk_app_boxspawner"
        },
        "com.robodk.app.curveutilities": {
            "N": "Curve Utilities",
            "F": "com_robodk_app_curveutilities.rdkp",
            "I": "com_robodk_app_curveutilities.svg",
            "MD": "com_robodk_app_curveutilities.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Curve Utilities App for RoboDK adds tools to edit, import and export curves and points.",
            "V": "2.2.1",
            "DC": "2023-01-16T21:00:40.085391Z",
            "DM": "2025-04-28T19:56:42.950856Z",
            "ID": "com.robodk.app.curveutilities",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/CurveUtilities",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/CurveUtilities"
            },
            "BN": "com_robodk_app_curveutilities"
        },
        "com.robodk.app.cycletime": {
            "N": "Cycle Time",
            "F": "com_robodk_app_cycletime.rdkp",
            "I": "com_robodk_app_cycletime.png",
            "MD": "com_robodk_app_cycletime.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Cycle Time App for RoboDK is a toolbox for cycle time estimation of robot programs.",
            "V": "1.0.0",
            "DC": "2023-10-18T21:00:40.085391Z",
            "DM": "2023-11-03T19:56:43.010841Z",
            "ID": "com.robodk.app.cycletime",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/General.html#CycleTime",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/CycleTime"
            },
            "BN": "com_robodk_app_cycletime"
        },
        "com.robodk.app.filmmaker": {
            "N": "FilmMaker",
            "F": "com_robodk_app_filmmaker.rdkp",
            "I": "com_robodk_app_filmmaker.svg",
            "MD": "com_robodk_app_filmmaker.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The FilmMaker App for RoboDK is designed to help you create cinematic camera paths for your RoboDK projects.",
            "V": "1.4.0",
            "DC": "2023-05-03T16:07:30.328Z",
            "DM": "2023-11-03T19:56:44.457059Z",
            "ID": "com.robodk.app.filmmaker",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_app_filmmaker"
        },
        "com.robodk.app.gamecontroller": {
            "N": "Game Controller",
            "F": "com_robodk_app_gamecontroller.rdkp",
            "I": "com_robodk_app_gamecontroller.png",
            "MD": "com_robodk_app_gamecontroller.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Game Controller App for RoboDK allows you to control your robot arm using a game controller.",
            "V": "1.1.0",
            "DC": "2023-01-16T21:00:40.208025Z",
            "DM": "2023-11-03T19:56:43.058623Z",
            "ID": "com.robodk.app.gamecontroller",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/GameController",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/GameController"
            },
            "BN": "com_robodk_app_gamecontroller"
        },
        "com.robodk.app.imageprocessingeditor": {
            "N": "Image Processing Editor",
            "F": "com_robodk_app_imageprocessingeditor.rdkp",
            "I": "com_robodk_app_imageprocessingeditor.svg",
            "MD": "com_robodk_app_imageprocessingeditor.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Image Processing Editor App for RoboDK is a simple 2D image processing utility to create filtering and detecting pipelines.",
            "V": "1.1.1",
            "DC": "2022-12-21T15:59:55.382797Z",
            "DM": "2023-01-10T20:18:34.714116Z",
            "ID": "com.robodk.app.imageprocessingeditor",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_app_imageprocessingeditor"
        },
        "com.robodk.app.importdxf": {
            "N": "Import DXF",
            "F": "com_robodk_app_importdxf.rdkp",
            "I": "com_robodk_app_importdxf.png",
            "MD": "com_robodk_app_importdxf.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Import DXF App for RoboDK allows you to import lines, arcs, circles, polylines and splines from DXF files as curves into RoboDK.",
            "V": "1.1.0",
            "DC": "2023-08-22T12:38:29.801Z",
            "DM": "2025-04-28T19:56:44.721119Z",
            "ID": "com.robodk.app.importdxf",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_app_importdxf"
        },
        "com.robodk.app.itemutilities": {
            "N": "Item Utilities",
            "F": "com_robodk_app_itemutilities.rdkp",
            "MD": "com_robodk_app_itemutilities.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Item Utilities App for RoboDK adds utility functions to manipulate Items, such as objects and robots.",
            "V": "1.0.2",
            "DC": "2023-01-16T21:00:40.336671Z",
            "DM": "2025-04-07T19:56:43.099865Z",
            "ID": "com.robodk.app.itemutilities",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ItemUtilities",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ItemUtilities"
            },
            "BN": "com_robodk_app_itemutilities"
        },
        "com.robodk.app.machining-tools": {
            "N": "Machining Tools",
            "F": "com_robodk_app_machining-tools.rdkp",
            "I": "com_robodk_app_machining-tools.svg",
            "MD": "com_robodk_app_machining-tools.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Machining tools App for RoboDK helps you with robot machining projects and properly calibrating your milling spindle and tools for machining.",
            "V": "1.0.0",
            "DC": "2023-01-16T19:08:31.948917Z",
            "DM": "2023-01-16T19:08:31.948917Z",
            "ID": "com.robodk.app.machining-tools",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_app_machining-tools"
        },
        "com.robodk.app.objectdeleter": {
            "N": "Object Deleter",
            "F": "com_robodk_app_objectdeleter.rdkp",
            "I": "com_robodk_app_objectdeleter.svg",
            "MD": "com_robodk_app_objectdeleter.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Object Deleter App for RoboDK adds customizable zones to delete objects.",
            "V": "1.0.0",
            "DC": "2023-01-16T21:00:40.472794Z",
            "DM": "2023-11-03T19:56:43.153893Z",
            "ID": "com.robodk.app.objectdeleter",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ObjectDeleter",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ObjectDeleter"
            },
            "BN": "com_robodk_app_objectdeleter"
        },
        "com.robodk.app.pointutilities": {
            "N": "Point Utilities",
            "F": "com_robodk_app_pointutilities.rdkp",
            "I": "com_robodk_app_pointutilities.svg",
            "MD": "com_robodk_app_pointutilities.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Point Utilities App for RoboDK adds tools to generate and edit point objects.",
            "V": "1.1.1",
            "DC": "2023-01-16T21:00:40.602913Z",
            "DM": "2023-11-03T19:56:43.232043Z",
            "ID": "com.robodk.app.pointutilities",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/PointUtilities",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/PointUtilities"
            },
            "BN": "com_robodk_app_pointutilities"
        },
        "com.robodk.app.probing": {
            "N": "Probing",
            "F": "com_robodk_app_probing_a8039cbfff9a9cc770733c2c531ca009.rdkp",
            "I": "com_robodk_app_probing_a8039cbfff9a9cc770733c2c531ca009.svg",
            "MD": "com_robodk_app_probing_a8039cbfff9a9cc770733c2c531ca009.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Probing App for RoboDK allows you to create probing sequences for automated part alignment.",
            "V": "1.2.0",
            "DC": "2023-11-16T14:36:56.233Z",
            "DM": "2024-04-08T14:36:56.233Z",
            "ID": "com.robodk.app.probing",
            "E": "info@robodk.com",
            "CF": 1,
            "PX": {
                "eur": 6000,
                "usd": 6500,
                "cad": 8500
            },
            "link": {
                "homepage": "https://robodk.com"
            },
            "BN": "com_robodk_app_probing_a8039cbfff9a9cc770733c2c531ca009"
        },
        "com.robodk.app.progutilities": {
            "N": "Program Utilities",
            "F": "com_robodk_app_progutilities.rdkp",
            "I": "com_robodk_app_progutilities.png",
            "MD": "com_robodk_app_progutilities.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Program utilities App for RoboDK adds tools to edit programs and program instructions.",
            "V": "1.1.0",
            "DC": "2023-01-16T21:00:40.730028Z",
            "DM": "2023-11-03T19:56:43.296245Z",
            "ID": "com.robodk.app.progutilities",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ProgUtilities",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ProgUtilities"
            },
            "BN": "com_robodk_app_progutilities"
        },
        "com.robodk.app.reachability": {
            "N": "Reachability",
            "F": "com_robodk_app_reachability.rdkp",
            "I": "com_robodk_app_reachability.svg",
            "MD": "com_robodk_app_reachability.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Reachability App for RoboDK adds preview capabilities of reachable tool poses from the current position.",
            "V": "1.0.0",
            "DC": "2023-01-16T21:00:41.237507Z",
            "DM": "2023-11-03T19:56:43.755019Z",
            "ID": "com.robodk.app.reachability",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/Reachability",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/Reachability"
            },
            "BN": "com_robodk_app_reachability"
        },
        "com.robodk.app.record": {
            "N": "Record",
            "F": "com_robodk_app_record.rdkp",
            "I": "com_robodk_app_record.svg",
            "MD": "com_robodk_app_record.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Record App for RoboDK adds cinematic recording capabilities to RoboDK.",
            "V": "1.1.0",
            "DC": "2023-01-16T21:00:41.377634Z",
            "DM": "2024-12-11T19:56:43.802948Z",
            "ID": "com.robodk.app.record",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/Record",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/Record"
            },
            "BN": "com_robodk_app_record"
        },
        "com.robodk.app.robocharts": {
            "N": "RoboCharts",
            "F": "com_robodk_app_robocharts.rdkp",
            "I": "com_robodk_app_robocharts.svg",
            "MD": "com_robodk_app_robocharts.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The RoboCharts App for RoboDK adds graphical statistics of trajectories and joint usage of robot programs.",
            "V": "1.0.0",
            "DC": "2024-01-23T21:00:40.085391Z",
            "DM": "2024-01-23T21:00:40.085391Z",
            "ID": "com.robodk.app.robocharts",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_app_robocharts"
        },
        "com.robodk.app.robodktutorial": {
            "N": "RoboDK Tutorial",
            "F": "com_robodk_app_robodktutorial.rdkp",
            "I": "com_robodk_app_robodktutorial.svg",
            "MD": "com_robodk_app_robodktutorial.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The RoboDK Tutorial App constitutes a comprehensive guide for new users.",
            "V": "1.0.0",
            "DC": "2023-08-29T13:00:44.968766Z",
            "DM": "2023-08-29T13:00:44.968766Z",
            "ID": "com.robodk.app.robodktutorial",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_app_robodktutorial"
        },
        "com.robodk.app.robotcalibrationtools": {
            "N": "Robot Calibration Tools",
            "F": "com_robodk_app_robotcalibrationtools_41404ba22808f8c1cc8b75ed6d3da0b8.rdkp",
            "I": "com_robodk_app_robotcalibrationtools_41404ba22808f8c1cc8b75ed6d3da0b8.svg",
            "MD": "com_robodk_app_robotcalibrationtools_41404ba22808f8c1cc8b75ed6d3da0b8.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Robot Calibration Tools App for RoboDK adds the necessary tools to calibrate a robot with RoboDK.",
            "V": "1.1.0",
            "DC": "2022-12-21T15:59:56.826799Z",
            "DM": "2025-04-24T20:18:34.845115Z",
            "ID": "com.robodk.app.robotcalibrationtools",
            "E": "info@robodk.com",
            "CF": 1,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Robot-Calibration-LaserTracker.html"
            },
            "BN": "com_robodk_app_robotcalibrationtools_41404ba22808f8c1cc8b75ed6d3da0b8"
        },
        "com.robodk.app.rrscomau": {
            "N": "RRS for Comau",
            "F": "com_robodk_app_rrscomau_07d6a19de31126cb7ebbc097f66899fa.rdkp",
            "I": "com_robodk_app_rrscomau_07d6a19de31126cb7ebbc097f66899fa.png",
            "MD": "com_robodk_app_rrscomau_07d6a19de31126cb7ebbc097f66899fa.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The RRS for Comau App for RoboDK provides the necessary functions to parse a RoboDK program with Realistic Robot Simulation (RRS)",
            "V": "1.1.0",
            "DC": "2023-11-22T19:50:49.259850Z",
            "DM": "2024-09-09T19:50:49.259850Z",
            "ID": "com.robodk.app.rrscomau",
            "E": "info@robodk.com",
            "CF": 1,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/RRS.html"
            },
            "BN": "com_robodk_app_rrscomau_07d6a19de31126cb7ebbc097f66899fa"
        },
        "com.robodk.app.rrsfanuc": {
            "N": "RRS for Fanuc",
            "F": "com_robodk_app_rrsfanuc_2046d862f6458103cc681af3fc4df387.rdkp",
            "I": "com_robodk_app_rrsfanuc_2046d862f6458103cc681af3fc4df387.svg",
            "MD": "com_robodk_app_rrsfanuc_2046d862f6458103cc681af3fc4df387.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The RRS for Fanuc App for RoboDK provides the necessary functions to parse a RoboDK program with Realistic Robot Simulation (RRS)",
            "V": "1.1.0",
            "DC": "2024-04-23T19:50:49.259850Z",
            "DM": "2024-09-09T19:50:49.259850Z",
            "ID": "com.robodk.app.rrsfanuc",
            "E": "info@robodk.com",
            "CF": 1,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/RRS.html"
            },
            "BN": "com_robodk_app_rrsfanuc_2046d862f6458103cc681af3fc4df387"
        },
        "com.robodk.app.sensor2d": {
            "N": "Sensor2D",
            "F": "com_robodk_app_sensor2d.rdkp",
            "I": "com_robodk_app_sensor2d.png",
            "MD": "com_robodk_app_sensor2d.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Sensor2D Add-in for RoboDK allows you to simulate safety laser scanners.",
            "V": "1.0.0",
            "DC": "2024-12-25T14:34:53.697Z",
            "DM": "2024-12-25T14:34:53.697Z",
            "ID": "com.robodk.app.sensor2d",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com"
            },
            "BN": "com_robodk_app_sensor2d"
        },
        "com.robodk.app.setstyle": {
            "N": "Set Style",
            "F": "com_robodk_app_setstyle.rdkp",
            "I": "com_robodk_app_setstyle.svg",
            "MD": "com_robodk_app_setstyle.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Set Style App for RoboDK adds quick appearance presets to edit curves, points and objects.",
            "V": "1.0.1",
            "DC": "2023-01-16T21:00:41.506751Z",
            "DM": "2023-11-03T19:56:43.853495Z",
            "ID": "com.robodk.app.setstyle",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/SetStyle",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/SetStyle"
            },
            "BN": "com_robodk_app_setstyle"
        },
        "com.robodk.app.settingsimportexport": {
            "N": "Settings Import-Export",
            "F": "com_robodk_app_settingsimportexport.rdkp",
            "I": "com_robodk_app_settingsimportexport.svg",
            "MD": "com_robodk_app_settingsimportexport.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Import-Export Settings App for RoboDK allows you to export and import RoboDK settings as an INI file.",
            "V": "1.0.0",
            "DC": "2024-04-18T11:58:15.425Z",
            "DM": "2024-04-18T11:58:15.425Z",
            "ID": "com.robodk.app.settingsimportexport",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Add-ins.html",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/SettingsImportExport"
            },
            "BN": "com_robodk_app_settingsimportexport"
        },
        "com.robodk.app.shape": {
            "N": "Components",
            "F": "com_robodk_app_shape.rdkp",
            "I": "com_robodk_app_shape.png",
            "MD": "com_robodk_app_shape.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Components Add-in for RoboDK adds the necessary tools to create 3D objects and mechanisms in RoboDK. This add-in was previously known as the Shape Add-in.",
            "V": "1.1.2",
            "DC": "2024-12-11T13:47:46.115Z",
            "DM": "2024-12-11T13:47:46.115Z",
            "ID": "com.robodk.app.shape",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Addin-Shape.html#AddinShape"
            },
            "BN": "com_robodk_app_shape"
        },
        "com.robodk.app.simplifymesh": {
            "N": "Simplify Mesh",
            "F": "com_robodk_app_simplifymesh.rdkp",
            "I": "com_robodk_app_simplifymesh.svg",
            "MD": "com_robodk_app_simplifymesh.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Simplify Mesh App for RoboDK reduces the complexity of 3D objects by minimizing the number of faces and triangles.",
            "V": "1.2.0",
            "DC": "2024-02-27T16:07:30.328Z",
            "DM": "2024-10-10T20:21:21.057Z",
            "ID": "com.robodk.app.simplifymesh",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Collision-Avoidance.html#FasterCollisionCheck"
            },
            "BN": "com_robodk_app_simplifymesh"
        },
        "com.robodk.app.snapshot": {
            "N": "Snapshot",
            "F": "com_robodk_app_snapshot.rdkp",
            "I": "com_robodk_app_snapshot.svg",
            "MD": "com_robodk_app_snapshot.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Snapshot App for RoboDK adds high resolution snapshot (print screen) capabilities to RoboDK.",
            "V": "1.0.1",
            "DC": "2023-01-16T21:00:41.641875Z",
            "DM": "2023-11-03T19:56:43.907386Z",
            "ID": "com.robodk.app.snapshot",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/Snapshot",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/Snapshot"
            },
            "BN": "com_robodk_app_snapshot"
        },
        "com.robodk.app.sound": {
            "N": "Sound",
            "F": "com_robodk_app_sound.rdkp",
            "I": "com_robodk_app_sound.svg",
            "MD": "com_robodk_app_sound.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Sound App for RoboDK adds programmable sound effects and background music/noise to RoboDK stations.",
            "V": "1.0.1",
            "DC": "2023-05-16T17:00:00.000Z",
            "DM": "2023-12-29T13:05:33.677Z",
            "ID": "com.robodk.app.sound",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Getting-Started.html"
            },
            "BN": "com_robodk_app_sound"
        },
        "com.robodk.app.surfacepatterngenerator": {
            "N": "Surface Pattern Generator",
            "F": "com_robodk_app_surfacepatterngenerator.rdkp",
            "I": "com_robodk_app_surfacepatterngenerator.png",
            "MD": "com_robodk_app_surfacepatterngenerator.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Surface Pattern Generator (SPG) App for RoboDK lets you generate simple surface patterns on an object surface.",
            "V": "1.0.1",
            "DC": "2023-01-16T21:00:41.781001Z",
            "DM": "2023-11-03T19:56:43.967666Z",
            "ID": "com.robodk.app.surfacepatterngenerator",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/SurfacePatternGenerator",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/SurfacePatternGenerator"
            },
            "BN": "com_robodk_app_surfacepatterngenerator"
        },
        "com.robodk.app.sweptvolume": {
            "N": "Swept Volume",
            "F": "com_robodk_app_sweptvolume.rdkp",
            "I": "com_robodk_app_sweptvolume.png",
            "MD": "com_robodk_app_sweptvolume.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Swept Volume App for RoboDK generates 3D volumes of the robot work envelope for a specific program.",
            "V": "1.0.2",
            "DC": "2023-09-27T16:07:30.328Z",
            "DM": "2024-10-10T19:55:50.785346Z",
            "ID": "com.robodk.app.sweptvolume",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_app_sweptvolume"
        },
        "com.robodk.app.twintool": {
            "N": "TwinTool",
            "F": "com_robodk_app_twintool_71b915391a7e52e702d6d8a3b0e3954a.rdkp",
            "I": "com_robodk_app_twintool_71b915391a7e52e702d6d8a3b0e3954a.svg",
            "MD": "com_robodk_app_twintool_71b915391a7e52e702d6d8a3b0e3954a.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The TwinTool App for RoboDK is an automated tool calibration (TCP) for robot tools.",
            "V": "1.0.4",
            "DC": "2022-12-21T15:55:11.367967Z",
            "DM": "2023-01-10T20:18:35.096428Z",
            "ID": "com.robodk.app.twintool",
            "E": "info@robodk.com",
            "CF": 1,
            "PX": {
                "eur": 7995,
                "usd": 7995,
                "cad": 9000
            },
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Robot-Automatic-Calibration-TwinTool.html#TwinTool"
            },
            "BN": "com_robodk_app_twintool_71b915391a7e52e702d6d8a3b0e3954a"
        },
        "com.robodk.app.twintrack": {
            "N": "TwinTrack",
            "F": "com_robodk_app_twintrack_b927e809e92aacf4d5fed27bc2f4c5be.rdkp",
            "I": "com_robodk_app_twintrack_b927e809e92aacf4d5fed27bc2f4c5be.svg",
            "MD": "com_robodk_app_twintrack_b927e809e92aacf4d5fed27bc2f4c5be.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The TwinTrack App for RoboDK allows you to easily replay human movements with a robot for fast and reliable automation (teach robots by demonstration).",
            "V": "1.1.0",
            "DC": "2023-01-10T20:18:35.096428Z",
            "DM": "2023-11-03T19:57:45.983560Z",
            "ID": "com.robodk.app.twintrack",
            "E": "info@robodk.com",
            "CF": 1,
            "PX": {
                "eur": 24950,
                "usd": 24950,
                "cad": 32955
            },
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/TwinTrack.html#TwinTrack"
            },
            "BN": "com_robodk_app_twintrack_b927e809e92aacf4d5fed27bc2f4c5be"
        },
        "com.robodk.app.universalrobots": {
            "N": "Universal Robots",
            "F": "com_robodk_app_universalrobots.rdkp",
            "I": "com_robodk_app_universalrobots.svg",
            "MD": "com_robodk_app_universalrobots.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "Provide Universal Robots utilities, such as active monitoring.",
            "V": "1.0.0",
            "DC": "2023-02-21T13:34:16.786Z",
            "DM": "2023-02-21T13:34:16.786Z",
            "ID": "com.robodk.app.universalrobots",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Robots-Universal-Robots.html"
            },
            "BN": "com_robodk_app_universalrobots"
        },
        "com.robodk.app.viewmanager": {
            "N": "View Manager",
            "F": "com_robodk_app_viewmanager.rdkp",
            "I": "com_robodk_app_viewmanager.svg",
            "MD": "com_robodk_app_viewmanager.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The View Manager App for RoboDK adds 3D view and interface presets.",
            "V": "1.0.0",
            "DC": "2023-01-16T21:00:41.915123Z",
            "DM": "2023-11-03T19:56:44.062321Z",
            "ID": "com.robodk.app.viewmanager",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ViewManager",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ViewManager"
            },
            "BN": "com_robodk_app_viewmanager"
        },
        "com.robodk.app.viewutilities": {
            "N": "View Utilities",
            "F": "com_robodk_app_viewutilities.rdkp",
            "I": "com_robodk_app_viewutilities.png",
            "MD": "com_robodk_app_viewutilities.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The View Utilities App for RoboDK provide bulk visibility functions (visible/hidden) to RoboDK.",
            "V": "1.1.0",
            "DC": "2023-01-16T21:00:42.054249Z",
            "DM": "2023-11-03T19:56:44.304762Z",
            "ID": "com.robodk.app.viewutilities",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ViewUtilities",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAppLoader/Apps/ViewUtilities"
            },
            "BN": "com_robodk_app_viewutilities"
        },
        "com.robodk.app.weavegenerator": {
            "N": "Weave Generator",
            "F": "com_robodk_app_weavegenerator.rdkp",
            "I": "com_robodk_app_weavegenerator.svg",
            "MD": "com_robodk_app_weavegenerator.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Weave Generator App for RoboDK provides tools to edit a path, adding weaving patterns and weld beads objects.",
            "V": "1.0.0",
            "DC": "2022-12-21T15:59:56.988799Z",
            "DM": "2023-01-10T20:18:34.974428Z",
            "ID": "com.robodk.app.weavegenerator",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_app_weavegenerator"
        },
        "com.robodk.app.welding": {
            "N": "Welding",
            "F": "com_robodk_app_welding_5808693a854a207676d60f217602a96c.rdkp",
            "I": "com_robodk_app_welding_5808693a854a207676d60f217602a96c.svg",
            "MD": "com_robodk_app_welding_5808693a854a207676d60f217602a96c.md",
            "P": "RoboDK Inc.",
            "C": "App",
            "D": "The Welding App for RoboDK allows you to use different parametric welding instructions in the RoboDK program sequencies.",
            "V": "1.0.10",
            "DC": "2023-11-16T14:36:56.233Z",
            "DM": "2024-06-14T08:50:25.590Z",
            "ID": "com.robodk.app.welding",
            "E": "info@robodk.com",
            "CF": 1,
            "link": {
                "homepage": "https://robodk.com",
                "docs": "https://robodk.com/doc/en/Addin-Welding.html#AddinWelding"
            },
            "BN": "com_robodk_app_welding_5808693a854a207676d60f217602a96c"
        },
        "com.robodk.plugin.collisionfreeplanner": {
            "N": "Collision Free Planner",
            "F": "com_robodk_plugin_collisionfreeplanner.rdkp",
            "I": "com_robodk_plugin_collisionfreeplanner.svg",
            "MD": "com_robodk_plugin_collisionfreeplanner.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Collision Free Planner Plug-in for RoboDK automatically creates collision-free paths within the robot's workspace using probabilistic roadmap (PRM).",
            "V": "1.2.1",
            "DC": "2023-01-16T13:26:36.719770Z",
            "DM": "2024-09-19T19:50:56.976162Z",
            "ID": "com.robodk.plugin.collisionfreeplanner",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Collision-Avoidance.html#CollisionPRM"
            },
            "BN": "com_robodk_plugin_collisionfreeplanner"
        },
        "com.robodk.plugin.filemanager": {
            "N": "File Manager",
            "F": "com_robodk_plugin_filemanager.rdkp",
            "I": "com_robodk_plugin_filemanager.svg",
            "MD": "com_robodk_plugin_filemanager.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The File Manager is an add-in for RoboDK that provides a user interface for managing files and directories on robot control systems.",
            "V": "1.3.2",
            "DC": "2024-07-24T16:48:40.000000Z",
            "DM": "2024-10-28T14:13:14.000000Z",
            "ID": "com.robodk.plugin.filemanager",
            "E": "info@robodk.com",
            "CF": 1,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/File-Manager.html"
            },
            "BN": "com_robodk_plugin_filemanager"
        },
        "com.robodk.plugin.opc-ua": {
            "N": "OPC-UA",
            "F": "com_robodk_plugin_opc-ua.rdkp",
            "MD": "com_robodk_plugin_opc-ua.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The OPC UA Plug-in for RoboDK allows you to add OPC UA compatibility to your RoboDK projects.",
            "V": "1.1.0",
            "DC": "2023-01-11T02:21:20.600212Z",
            "DM": "2024-08-15T19:50:57.051776Z",
            "ID": "com.robodk.plugin.opc-ua",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/Plugin-OPC-UA",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/Plugin-OPC-UA"
            },
            "BN": "com_robodk_plugin_opc-ua"
        },
        "com.robodk.plugin.pluginattachobject": {
            "N": "Attach Object",
            "F": "com_robodk_plugin_pluginattachobject.rdkp",
            "MD": "com_robodk_plugin_pluginattachobject.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Attach Object Plug-in for RoboDK can dynamically attach multiple objects to a robot joint.",
            "V": "1.0.0",
            "DC": "2023-01-11T02:21:20.919336Z",
            "DM": "2023-11-03T19:50:57.149752Z",
            "ID": "com.robodk.plugin.pluginattachobject",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAttachObject",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAttachObject"
            },
            "BN": "com_robodk_plugin_pluginattachobject"
        },
        "com.robodk.plugin.pluginattachview": {
            "N": "Attach View",
            "F": "com_robodk_plugin_pluginattachview.rdkp",
            "MD": "com_robodk_plugin_pluginattachview.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Attach View Plug-in for RoboDK adds the ability to anchor the position of the view to a robot, tool or frame.",
            "V": "1.0.0",
            "DC": "2023-01-11T02:21:21.118336Z",
            "DM": "2023-11-03T19:50:57.220779Z",
            "ID": "com.robodk.plugin.pluginattachview",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAttachView",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginAttachView"
            },
            "BN": "com_robodk_plugin_pluginattachview"
        },
        "com.robodk.plugin.pluginballbartracker": {
            "N": "Ballbar Tracker",
            "F": "com_robodk_plugin_pluginballbartracker.rdkp",
            "MD": "com_robodk_plugin_pluginballbartracker.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Ballbar Tracker Plug-in for RoboDK allows you to attach a ballbar to a robot.",
            "V": "1.0.0",
            "DC": "2023-01-11T02:21:21.290172Z",
            "DM": "2023-11-03T19:50:57.268096Z",
            "ID": "com.robodk.plugin.pluginballbartracker",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginBallbarTracker",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginBallbarTracker"
            },
            "BN": "com_robodk_plugin_pluginballbartracker"
        },
        "com.robodk.plugin.plugincablesimulation": {
            "N": "Cable Simulation",
            "F": "com_robodk_plugin_plugincablesimulation.rdkp",
            "MD": "com_robodk_plugin_plugincablesimulation.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Cable Simulation Plug-in for RoboDK provides cable tray simulation for external axes.",
            "V": "1.0.0",
            "DC": "2023-11-03T19:50:57.975477Z",
            "DM": "2023-11-03T19:50:57.975477Z",
            "ID": "com.robodk.plugin.plugincablesimulation",
            "E": "info@robodk.com",
            "CF": 1,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_plugin_plugincablesimulation"
        },
        "com.robodk.plugin.plugincnc": {
            "N": "RoboDK CNC",
            "F": "com_robodk_plugin_plugincnc.rdkp",
            "I": "com_robodk_plugin_plugincnc.svg",
            "MD": "com_robodk_plugin_plugincnc.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The RoboDK CNC Plug-in is designed to facilitate the execution of large robot programs on controllers with limited memory capacity.",
            "V": "1.0.0",
            "DC": "2024-01-30T18:34:47.968915Z",
            "DM": "2024-01-30T18:34:47.968915Z",
            "ID": "com.robodk.plugin.plugincnc",
            "E": "info@robodk.com",
            "CF": 1,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/RoboDK-CNC.html"
            },
            "BN": "com_robodk_plugin_plugincnc"
        },
        "com.robodk.plugin.plugincollisionsensor": {
            "N": "Collision Sensor",
            "F": "com_robodk_plugin_plugincollisionsensor.rdkp",
            "MD": "com_robodk_plugin_plugincollisionsensor.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Collision Sensor Plug-in for RoboDK adds the ability to simulate sensors, such as a laser sensors or contact switches.",
            "V": "1.0.0",
            "DC": "2023-01-11T02:21:21.645367Z",
            "DM": "2023-11-03T19:50:57.345133Z",
            "ID": "com.robodk.plugin.plugincollisionsensor",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginCollisionSensor",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginCollisionSensor"
            },
            "BN": "com_robodk_plugin_plugincollisionsensor"
        },
        "com.robodk.plugin.plugincoordinatedmotion": {
            "N": "Coordinated Motion",
            "F": "com_robodk_plugin_plugincoordinatedmotion.rdkp",
            "MD": "com_robodk_plugin_plugincoordinatedmotion.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Coordinated Motion Plug-in for RoboDK adds the ability to synchronize robots by copying joints, copying stance or keeping constant TCP offset.",
            "V": "1.0.0",
            "DC": "2024-07-26T19:50:57.220779Z",
            "DM": "2024-07-26T19:50:57.220779Z",
            "ID": "com.robodk.plugin.plugincoordinatedmotion",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_plugin_plugincoordinatedmotion"
        },
        "com.robodk.plugin.plugindisplaypanel": {
            "N": "Display Panel",
            "F": "com_robodk_plugin_plugindisplaypanel.rdkp",
            "I": "com_robodk_plugin_plugindisplaypanel.svg",
            "MD": "com_robodk_plugin_plugindisplaypanel.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Display Panel Plug-in for RoboDK adds the ability to render text and images in the simulation environment.",
            "V": "1.1.0",
            "DC": "2023-01-16T13:26:37.910854Z",
            "DM": "2023-11-03T19:50:57.393143Z",
            "ID": "com.robodk.plugin.plugindisplaypanel",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_plugin_plugindisplaypanel"
        },
        "com.robodk.plugin.pluginiomonitor": {
            "N": "IO Monitor",
            "F": "com_robodk_plugin_pluginiomonitor.rdkp",
            "I": "com_robodk_plugin_pluginiomonitor.svg",
            "MD": "com_robodk_plugin_pluginiomonitor.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The IO Monitor Plug-in for RoboDK provides a user interface to monitor station and item parameters, including IOs.",
            "V": "1.3.0",
            "DC": "2023-11-03T19:50:57.525921Z",
            "DM": "2025-01-10T14:00:00.000000Z",
            "ID": "com.robodk.plugin.pluginiomonitor",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_plugin_pluginiomonitor"
        },
        "com.robodk.plugin.pluginlocktcp": {
            "N": "Lock TCP",
            "F": "com_robodk_plugin_pluginlocktcp.rdkp",
            "MD": "com_robodk_plugin_pluginlocktcp.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Lock TCP Plug-in for RoboDK adds the ability to lock the TCP position for a 6 axis robot mounted on a synchronized external axis.",
            "V": "1.0.0",
            "DC": "2023-01-11T02:21:22.562275Z",
            "DM": "2023-11-03T19:50:57.593306Z",
            "ID": "com.robodk.plugin.pluginlocktcp",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginLockTCP",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginLockTCP"
            },
            "BN": "com_robodk_plugin_pluginlocktcp"
        },
        "com.robodk.plugin.pluginlvdt": {
            "N": "Linear Sensor (LVDT)",
            "F": "com_robodk_plugin_pluginlvdt.rdkp",
            "MD": "com_robodk_plugin_pluginlvdt.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Linear Gage Sensor (LVDT) Plug-in for RoboDK can dynamically move a linear gage sensor, such as an LVDT.",
            "V": "1.0.0",
            "DC": "2023-01-11T02:21:22.812470Z",
            "DM": "2023-11-03T19:50:57.684068Z",
            "ID": "com.robodk.plugin.pluginlvdt",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginLVDT",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginLVDT"
            },
            "BN": "com_robodk_plugin_pluginlvdt"
        },
        "com.robodk.plugin.pluginpalletizing": {
            "N": "Palletizing",
            "F": "com_robodk_plugin_pluginpalletizing.rdkp",
            "I": "com_robodk_plugin_pluginpalletizing.svg",
            "MD": "com_robodk_plugin_pluginpalletizing.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Palletizing Plug-in for RoboDK provides a user interface to design and generate palletizing and depalletizing robot programs.",
            "V": "1.7.7",
            "DC": "2023-01-16T13:26:38.796697Z",
            "DM": "2025-03-18T14:00:00.000000Z",
            "ID": "com.robodk.plugin.pluginpalletizing",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Palletizing.html#Palletizing"
            },
            "BN": "com_robodk_plugin_pluginpalletizing"
        },
        "com.robodk.plugin.pluginuiadditions": {
            "N": "UI Additions",
            "F": "com_robodk_plugin_pluginuiadditions.rdkp",
            "MD": "com_robodk_plugin_pluginuiadditions.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The UI Additions Plug-in for RoboDK provides additional customization capabilities to the RoboDK user interface.",
            "V": "1.0.1",
            "DC": "2023-01-16T13:26:39.128999Z",
            "DM": "2023-11-07T17:59:46.706201Z",
            "ID": "com.robodk.plugin.pluginuiadditions",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/"
            },
            "BN": "com_robodk_plugin_pluginuiadditions"
        },
        "com.robodk.plugin.postprocessoreditor": {
            "N": "Post Processor Editor",
            "F": "com_robodk_plugin_postprocessoreditor.rdkp",
            "I": "com_robodk_plugin_postprocessoreditor.png",
            "MD": "com_robodk_plugin_postprocessoreditor.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Post Processor Editor Plug-in for RoboDK provides a user interface to edit RoboDK's Post Processors.",
            "V": "1.0.2",
            "DC": "2023-01-16T13:26:39.273139Z",
            "DM": "2024-11-06T19:50:58.068868Z",
            "ID": "com.robodk.plugin.postprocessoreditor",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://robodk.com/doc/en/Post-Processors.html#PPEditor"
            },
            "BN": "com_robodk_plugin_postprocessoreditor"
        },
        "com.robodk.plugin.robotpilot": {
            "N": "Robot Pilot",
            "F": "com_robodk_plugin_robotpilot.rdkp",
            "MD": "com_robodk_plugin_robotpilot.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The Robot Pilot Plug-in for RoboDK allows you to move the robot by incremental steps from the GUI.",
            "V": "1.0.0",
            "DC": "2023-01-11T02:21:24.286687Z",
            "DM": "2023-11-03T19:50:58.186288Z",
            "ID": "com.robodk.plugin.robotpilot",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginRobotPilot",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginRobotPilot"
            },
            "BN": "com_robodk_plugin_robotpilot"
        },
        "com.robodk.plugin.roboui": {
            "N": "RoboUI",
            "F": "com_robodk_plugin_roboui.rdkp",
            "MD": "com_robodk_plugin_roboui.md",
            "P": "RoboDK Inc.",
            "C": "Plug-in",
            "D": "The RoboUI Plug-in for RoboDK shows the possibility of integrating the ImGUI library to render a customized UI in the 3D scene window.",
            "V": "1.0.0",
            "DC": "2023-07-11T12:38:00.000000Z",
            "DM": "2023-07-11T12:38:00.000000Z",
            "ID": "com.robodk.plugin.roboui",
            "E": "info@robodk.com",
            "CF": 0,
            "link": {
                "homepage": "https://robodk.com/",
                "docs": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginRoboUI",
                "repos": "https://github.com/RoboDK/Plug-In-Interface/tree/master/PluginRoboUI"
            },
            "BN": "com_robodk_plugin_roboui"
        },
        "com.rprautomation.app.easyautomator": {
            "N": "Easy Automator",
            "F": "com_rprautomation_app_easyautomator.rdkp",
            "I": "com_rprautomation_app_easyautomator.png",
            "MD": "com_rprautomation_app_easyautomator.md",
            "P": "RPR Automation GmbH",
            "C": "App",
            "D": "The Easy Automator is a teach by demonstration solution for contact and contactless applications.",
            "V": "1.0.0",
            "DC": "2023-01-10T20:18:35.096428Z",
            "DM": "2024-11-07T19:57:46.527321Z",
            "ID": "com.rprautomation.app.easyautomator",
            "E": "hello@rpr-automation.com",
            "CF": 1,
            "link": {
                "homepage": "https://easy-automator.com/?utm_source=robodk&utm_medium=library",
                "docs": "https://resources.easy-automator.com/?utm_source=robodk&utm_medium=library"
            },
            "BN": "com_rprautomation_app_easyautomator"
        }
    }
}